import { IconSizes, Span, useThemeClass } from '@afterpaytouch/core'
import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'
import styles from './style.module.css'

interface InlinePaymentMethodProps {
  reversed?: boolean
  iconSize?: IconSizes
  icon: ReactNode
  paymentMethodInfo?: ReactNode
  paymentMethodName: string
  tooltip?: ReactNode
  disabled?: boolean
}

export const PaymentMethod: FunctionComponent<InlinePaymentMethodProps> = ({
  paymentMethodName,
  icon,
  paymentMethodInfo: paymentMethodDesc,
  tooltip,
  disabled = false,
}) => {
  const themeClass = useThemeClass()
  const containerClasses = clsx(styles.container)
  const paymentMethodDetailContainer = clsx(styles.paymentMethodDetailContainer, styles[themeClass])
  const iconClasses = clsx(styles.icon, disabled && styles.disabledIcon)

  return (
    <span className={containerClasses}>
      <span className={iconClasses}>{icon}</span>
      <span className={paymentMethodDetailContainer}>
        <span className={styles.paymentMethodNameContainer}>
          <Span bold>{paymentMethodName}</Span>
          {tooltip}
        </span>
        {paymentMethodDesc}
      </span>
    </span>
  )
}
